exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog #attachment {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin: 0;\n    padding: 0;\n    font-size: 20px;\n    cursor: pointer;\n    opacity: 0;\n    filter: alpha(opacity=0);\n    }\n    .login-registration-form-box.quick-tour-outer-box.log-help-desk-box .custom-select {\n        width: 93%;\n    }\n    .login-registration-form-box.quick-tour-outer-box.log-help-desk-box textarea.form-control {\n        border: 1px solid #ced4da;\n        border-radius: .25rem;\n    }\n    .help-margin {\n        margin-left: 10px;\n    }\n    .top-pera { \n    padding-bottom: 10px;\n    font-size: 15px;\n    font-weight: 500;\n   }\n    .form-check-input {\n    width: 17px;\n    height: 17px;\n}\n    .cl-button{\n    text-align: center;\n}\n    ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/mypackagedetail/mypackagedetail.component.css
// module id = ../../../../../src/app/home/mypackagedetail/mypackagedetail.component.css
// module chunks = common